import Mutations from '../../odata/mutations';

export default { ...new Mutations('xeroProfitAndLossReport'), ...new Mutations('xeroProfitAndLossReports') };
